/* Component Dependencies */
var commonHeaderTemplate = require('templates/commonHeader.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'commonHeader',
  template: {
    'commonHeader': commonHeaderTemplate
  }
});
